import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import './styles/scss/application.scss'

import favicon from './img/favicon.ico'

const TemplateWrapper = ({ children, location }) => (
  <div>
    <Helmet>
      <title>SwissMonkey</title>
      <link rel="shortcut icon" href={favicon} />
    </Helmet>
    <Navbar path={location.pathname}/>
    <div>{children()}</div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js